export const fonts = {
  primary: "'Ubuntu', sans-serif",
  karla: "'Karla', 'sans-serif'",
}
